import { render, staticRenderFns } from "./Y67TPrimaryEoiList.vue?vue&type=template&id=4fd4ddbc&scoped=true&"
import script from "./Y67TPrimaryEoiList.vue?vue&type=script&lang=js&"
export * from "./Y67TPrimaryEoiList.vue?vue&type=script&lang=js&"
import style0 from "./Y67TPrimaryEoiList.vue?vue&type=style&index=0&id=4fd4ddbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4ddbc",
  null
  
)

export default component.exports